import { React, useState, useMemo } from "react";
import apiService from "services/api";
import { useQuery } from "react-query";
import { CustomTable, CustomTabs } from "components";
import { FiSearch } from "react-icons/fi";
import { otTableColumns, leaveTableColumns, myLessonRecordsTableColumn } from "../constants";
import StaffStatistics from "./StaffStatistics";

// reactstrap components
import { Button, Row, Col } from "reactstrap";

import { Link, useParams } from "react-router-dom";
import StaffLessonRecords from "./StaffLessonRecords";
import StaffDetails from "./StaffDetails";
import StaffApplications from "./StaffApplications";
import StaffOt from "./StaffOt";

const ViewStaffPage = ({ type = "leave" }) => {
	const { staff_id } = useParams();
	const { data: staff, isLoading: loadingStaff } = useQuery(["staff", staff_id], () => apiService.staff.get(staff_id));

	const tabs = useMemo(
		() => [
			{
				title: "Staff Details",
				component: () => <StaffDetails staff={staff} type={type} />,
			},
			// { title: "Heat Map", component: () => <HeatMap staff={staff} /> },
			{ title: "Staff Leaves", component: () => <StaffApplications staff={staff} isLoading={loadingStaff} type={type} /> },
			{ title: "Staff OTs", component: () => <StaffOt staff={staff} isLoading={loadingStaff} type={type} /> },
			{ title: "Staff Lesson Records", component: () => <StaffLessonRecords staff={staff} isLoading={loadingStaff} type={type} /> },
			{ title: "Statistics", component: () => <StaffStatistics staff={staff} /> },
		],
		[staff]
	);

	return (
		<>
			<div className="content w-100">
				<div className="d-flex justify-content-between">
					<Link to="/staff">
						<button className="btn btn-sm btn-info" type="button">
							&lt; Back to staff
						</button>
					</Link>
					<Link to={`/staff/edit/${staff_id}`}>
						<button className="btn btn-sm btn-warning" type="button">
							Edit Staff
						</button>
					</Link>
				</div>
				<Row className="mt-5">
					<Col className="order-2 md:order-1">
						<CustomTabs tabs={tabs} />
					</Col>
				</Row>
			</div>
		</>
	);
};

export default ViewStaffPage;
